export const quizData = {
  categories: [
    {
      categoryName: "F.R.I.E.N.D.s",
      questions: [
        {
          question: "What is the name of Ross's kid ?",
          incorrectOptions: ["Joey", "Chandler", "Monica"],
          answer: "Ben",
        },
        {
          question: "What was Rachels first job ?",
          incorrectOptions: ["Doctor", "Web developer", "IT Engineer"],
          answer: "Waitress",
        },
        {
          question:
            "As a bestfriend, which food item did joey share with chandler?",
          incorrectOptions: ["Pizza", "Noodles", "Pasta"],
          answer: "Sandwich",
        },
        {
          question: "Who was the first to find out about Chandler & Monica ?",
          incorrectOptions: ["Ross", "Rachel", "Joey"],
          answer: "Phoebe",
        },
        {
          question: "What is name of Ross & Rachels daughter ?",
          incorrectOptions: ["Stephanie", "Bennie", "Lacey"],
          answer: "Emma",
        },
      ],
    },
    {
      categoryName: "Neog",
      questions: [
        {
          question: "Who is the CEO of Neog Camp ?",
          incorrectOptions: [
            "Tanay Pratap",
            "Akanksha Choudhary",
            "Vikram Santhalia",
          ],
          answer: "Tanvi Priya",
        },
        {
          question: "In which year did the first batch of Neog took place ?",
          incorrectOptions: ["2020", "2019", "2022"],
          answer: "2021",
        },
        {
          question: "What's the duration of camp ?",
          incorrectOptions: ["1 Year", "8 Months", "10 Months"],
          answer: "6 Months",
        },
        {
          question: "Who is the main mentor of Neog Camp ?",
          incorrectOptions: [
            "Tanvi Priya",
            "Akanksha Choudhary",
            "Vikram Santhalia",
          ],
          answer: "Tanay Pratap",
        },
        {
          question: "What was markOne project in levelZero ?",
          incorrectOptions: [
            "Profit Or Loss",
            "Minionese",
            "Fun With Triangles",
          ],
          answer: "CLI App",
        },
      ],
    },
    {
      categoryName: "How I Met Your Mother",
      questions: [
        {
          question: "What instrument does Ted steal for Robin?",
          incorrectOptions: ["A tuba", "A trumpet", "A saxophone"],
          answer: "French horn",
        },
        {
          question: "What embarrassing tattoo does Ted get in Season 3?",
          incorrectOptions: ["His mom's name", "Robin's name", "A Unicorn"],
          answer: "A Butterfly",
        },
        {
          question: "Which girl leaves Ted at the altar?",
          incorrectOptions: ["Robin", "Victoria", "Natalie"],
          answer: "Stella",
        },
        {
          question: "What season do Lily and Marshall get married?",
          incorrectOptions: ["Season 1", "Season 3", "Season 4"],
          answer: "Season 2",
        },
        {
          question:
            "What phrase does Robin constantly say on her pre-morning news show?",
          incorrectOptions: ["Like, so", "Yeah, yeah", "Uh...so"],
          answer: "But,ummm....",
        },
        {
          question: "What's the name of the bar the group frequents?",
          incorrectOptions: ["Brady Pub", "Central Perk", "Ace of Clubs"],
          answer: "MacLaren's Pub",
        },
      ],
    },
    {
      categoryName: "Suits",
      questions: [
        {
          question: "At the end of Suits Season 3, who does Mike leave Pearson Specter to work for instead?",
          incorrectOptions: ["Wakefield-Cady", "Rand, Kaldor & Zane", "Rand, Kaldor & Zane"],
          answer: "Sidwell Investment Group",
        },
        {
          question: "Harvey and Donna have a secret ritual involving a what?",
          incorrectOptions: ["spatula", "stapler", "whisk"],
          answer: "can opener",
        },
        {
          question: "Suits is set in a fictional law firm in ________?",
          incorrectOptions: ["Atlanta", "Chicago", "Austin"],
          answer: "New York City",
        },
        {
          question: "What network airs 'Suits?'",
          incorrectOptions: ["NBC", "CBS", "TNT"],
          answer: "USA",
        },
        {
          question:
            "Who is the female shark in charge of the 'Suits' law firm?",
          incorrectOptions: ["Rachel Zane", "Donna Paulsen", "None"],
          answer: "Jessica Pearson",
        },
        {
          question: "_____ is the firm's expert on all financial matters?",
          incorrectOptions: ["Charles Forstman", "Robert Zane", "Jeff Malone"],
          answer: "Louis Litt",
        },
      ],
    },
  ],
};
